import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AcmicService } from '@mapfre-design-library/src/public_api';
import { PifDiscountInfo } from '@models/billing';
import { PolicyTooltipService } from '@services/my-insurance/policy-tooltip.service';
import { InfoTooltipComponent } from '../info-tooltip/info-tooltip.component';

@Component({
  standalone: true,
  imports: [CommonModule, InfoTooltipComponent],
  selector: 'app-pif-discount',
  templateUrl: './pif-discount.component.html',
  styleUrls: ['./pif-discount.component.scss']
})
export class PifDiscountComponent implements OnInit, OnChanges {
  @Input() policy: any;
  @Input() variant: 'bn-overview' | 'policy-card' = 'policy-card';
  @ViewChild('pifTooltip') pifTooltip?: InfoTooltipComponent;

  pifDiscountInfo: PifDiscountInfo;
  pifEligible: boolean;
  isPaidInFull: boolean;
  hasPriorPif: boolean;
  savingsAmount: number;
  pifTooltipContent: string | null = null;
  isAcmic: boolean;

  get isMobile(): boolean {
    return this.policyTooltipService.isMobile;
  }

  constructor(
    private acmicService: AcmicService,
    private policyTooltipService: PolicyTooltipService
  ) {
    this.isAcmic = this.acmicService.isACMIC();
  }

  toggleTooltip(event: Event, tooltip: InfoTooltipComponent): void {
    event.stopPropagation();
    tooltip.toggle();
  }

  ngOnInit(): void {
    this.compute(this.policy);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['policy']?.currentValue) {
      this.compute(changes['policy'].currentValue);
    }
  }

  private compute(policy: any): void {
    this.pifDiscountInfo = policy?.pifDiscountInfo;
    this.pifEligible = this.pifDiscountInfo?.pifEligible;
    const outstandingBalance = 
                    (policy?.billingDetails[0]?.outstandingbalance ?? 0) +
                    (policy?.priorYearBalance?.theAmount ?? 0);
    const isDiscountApplied = !!this.pifDiscountInfo?.pifDiscountApplied;
    this.isPaidInFull = this.pifDiscountInfo?.isPaidInFull;
    this.hasPriorPif = this.pifEligible && isDiscountApplied && outstandingBalance > 0;
    this.savingsAmount = (this.pifDiscountInfo?.nonDiscountedPremium?.theAmount ?? 0) -
                          (this.pifDiscountInfo?.pifDiscountedPremium?.theAmount ?? 0);
    this.pifTooltipContent = this.policyTooltipService.getPifTooltip(policy);
  }
}
